/**
 * scroll-restore.js
 * Restores scroll position on collection pages after returning from a product page.
 * Fixes iOS Safari bfcache / scroll-reset behavior.
 *
 * IMPORTANT: Load without defer or async, just before </body> in theme.liquid:
 * <script src="{{ 'scroll-restore.js' | asset_url }}"></script>
 */

(function () {
  'use strict';

  function key() {
    return 'scr:' + window.location.pathname + window.location.search;
  }

  function save() {
    try {
      var y = window.scrollY || window.pageYOffset;
      if (y > 0) sessionStorage.setItem(key(), String(y));
    } catch (e) {}
  }

  function read() {
    try {
      return parseInt(sessionStorage.getItem(key()), 10) || 0;
    } catch (e) { return 0; }
  }

  function clear() {
    try { sessionStorage.removeItem(key()); } catch (e) {}
  }

  function isCollection() {
    return !!(
      document.getElementById('collection--list-grid') ||
      document.querySelector('[data-collections-grid]')
    );
  }

  function restore(y) {
    if (!y || y <= 0) return;
    requestAnimationFrame(function () {
      window.scrollTo(0, y);
      setTimeout(function () {
        window.scrollTo(0, y);
        if (Math.abs((window.scrollY || window.pageYOffset) - y) < 100) clear();
      }, 400);
    });
  }

  function init() {
    if (!isCollection()) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Save scroll position when user clicks a product link
    var grid = document.getElementById('collection--list-grid')
      || document.querySelector('[data-collections-grid]')
      || document;

    grid.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (link && link.getAttribute('href').indexOf('/products/') !== -1) {
        save();
      }
    });

    // Restore on normal page load (e.g. user hit back, page fully reloaded)
    var savedY = read();
    if (savedY > 0) restore(savedY);

    // Restore on iOS Safari bfcache (back button — page served from cache)
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        var y = read();
        if (y > 0) restore(y);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();